<script lang="ts">
    import { onMount } from "svelte";
    import { initSocket } from "../stores/socketStore";
    import Waiting from "../components/Waiting/Waiting.svelte";
    import { translation } from "../stores";
    import { roomStateStore } from "../stores/roomStateStore";
    import { roomStore } from "../stores/roomStore";
    import ErrorScreen from "../components/ErrorScreen/ErrorScreen.svelte";
    import { detectAltice } from "../utils/detectAltice";
    import { getQueryParams } from "../utils/getQueryParams";
    import PopUp from "../components/Custom/CustomPopUp.svelte";
    import { ROOM_CONNECTION_STATE } from "../types/Room/RoomConnectionState";
    import { get } from "svelte/store";
    import { roleStore } from "../stores/roleStore";
    import { setRole } from "../utils/setRole";
    import CallVideoClient from "../components/CallVideo/Role/CallVideoClient.svelte";
    import CallVideoExpert from "../components/CallVideo/Role/CallVideoExpert.svelte";
    import { navigateWithParams } from "../utils/navigation";

    export let params: Record<string, string> = {};

    let showPopup = true;
    let handsFreeConfirmed = false;
    $: room = $roomStore;
    let popupShownOnce = false;
    $: if (room?.type === "video" && !popupShownOnce) {
        showPopup = true;
        popupShownOnce = true;
    }

    $: role = get(roleStore);
    $: showPopup = role === "client" && room?.type === "video" && !handsFreeConfirmed;

    onMount(async () => {
        console.log("[NewCamera] request");
        detectAltice();
        setRole();
        const currentRole = get(roleStore);
        const { pin } = getQueryParams();

        try {
            const roomId = Number(params.room);
            if (isNaN(roomId)) {
                console.error("[NewCamera] Invalid room id:", params.room);
                return;
            }
            roomStateStore.set(ROOM_CONNECTION_STATE.CONNECTING);

            console.log("[NewCamera][onMount] room id:", roomId);
            console.log("[NewCamera][onMount] role:", currentRole);
            console.log("[NewCamera][onMount] pin:", pin);

            const socket = await initSocket(roomId, { role: currentRole, pin });
            console.log("[NewCamera] Socket", socket.id);
        } catch (err) {
            console.error(
                "[NewCamera] Impossible de connecter le socket :",
                err,
            );
        }
    });

    async function handlePopupConfirm() {
        handsFreeConfirmed = true;
        showPopup = false;
    }
</script>

<div id="video-container" class="flex flex-col justify-center flex-grow">
    {#if showPopup}
        <PopUp
            icon="fa fa-headphones"
            title={translation.handsFree.title}
            message={translation.handsFree.message}
            confirmLabel={translation.handsFree.confirmLabel}
            onConfirm={handlePopupConfirm}
        />
    {/if}

    {#if $roomStateStore === "CONNECTING"}
        <Waiting text={translation.alert.waitingAuthorization} />
    {:else if $roomStateStore === "CONNECTED" && $roomStore}
        {#if $roleStore === "client"}
            <CallVideoClient />
        {:else if $roleStore === "expert"}
            <CallVideoExpert />
        {/if}
    {:else if $roomStateStore === "REJECTED"}
        <ErrorScreen
            title={translation.alert.sessionFullError}
            onAction={() => {
                roomStateStore.set(ROOM_CONNECTION_STATE.IDLE);
                navigateWithParams("#/")
            }}
            actionLabel={translation.intro.backToHome}
        />
    {:else if $roomStateStore === "NOT_FOUND"}
        <ErrorScreen title="Room introuvable" />
    {:else if $roomStateStore === "ERROR"}
        <ErrorScreen
            title={translation.alert.roomError}
            onAction={() => {
                roomStateStore.set(ROOM_CONNECTION_STATE.IDLE);
                navigateWithParams("#/")
            }}
            actionLabel={translation.intro.backToHome}
        />
    {:else}
        <ErrorScreen
            title={$roomStateStore}
            onAction={() => {
                roomStateStore.set(ROOM_CONNECTION_STATE.IDLE);
                navigateWithParams("#/")
            }}
            actionLabel={translation.intro.backToHome}
        />
    {/if}
</div>
